__turbopack_context__.v({
  "Backdrop": "Checkbox-module-scss-module__uzhQzG__Backdrop",
  "CheckIcon": "Checkbox-module-scss-module__uzhQzG__CheckIcon",
  "Checkbox": "Checkbox-module-scss-module__uzhQzG__Checkbox",
  "CheckboxWrapper": "Checkbox-module-scss-module__uzhQzG__CheckboxWrapper",
  "Label": "Checkbox-module-scss-module__uzhQzG__Label",
  "Wrapper": "Checkbox-module-scss-module__uzhQzG__Wrapper",
});
